export default __webpack_public_path__ + "static/media/8d2f3d57b17989b1946a0feb5f18d2631581611496751.3c8ff8fd.webp";